import type { Aabb, StaticCollider } from "@townsy/contracts";

/** A fixture collider inside a venue room (the renderer picks the model from the id prefix). */
export const fixture = (id: string, b: Aabb): StaticCollider => ({ id, kind: "building", aabb: b });
